import React from 'react';
import { bool, object } from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import SingleVideoStoryWithPlayLists from './single-video-with-playlists';
import BlankStory from '../blank';

const VideoStory = props => {
  const syndicatedfrom = get(props, ['story', 'metadata', 'story-attributes', 'syndicatedfrom', 0]);

  return props.showSingleVidibleVideo && (syndicatedfrom === 'bqvideos' || 'vidible') ? (
    <SingleVideoStoryWithPlayLists {...props} />
  ) : (
    <BlankStory {...props} />
  );
};

VideoStory.propTypes = {
  showSingleVidibleVideo: bool,
  story: object
};

const mapStateToProps = state => ({
  publisherUrl: state.qt.config['sketches-host'],
  showSingleVidibleVideo: get(
    state,
    ['qt', 'config', 'features', 'malibu', 'single_vidible_video'],
    false
  )
});

export default connect(mapStateToProps, null)(VideoStory);
